import React, { PureComponent } from 'react';
import expectationResultFactory from '../../node_modules/jest-jasmine2/build/expectationResultFactory';

class ChatTop extends PureComponent {

    constructor(props) {
        super(props);

        this.handleClickSideMenu = this.handleClickSideMenu.bind(this);
        //this.handleClickRefresh = this.handleClickRefresh.bind(this);
        this.handleClickFeedback = this.handleClickFeedback.bind(this);

        this.state = {
          lang_is_active : false
        }
    }

    componentDidMount() {

    }

    handleClickSideMenu() {
      this.props.openSideMenu()
    }

    handleClickFeedback() {
      if (this.props.init === false) return 

      if (this.props.isLogin) {
        this.props.openFeedback()
      } else {
		this.props.controlOverlay({toggle:true, closeAll:false})
		this.props.loginAlert()
      }
	  
    }

    clickChatbotClose() {
      try {
        window.closeChatbot();  //App에서만 동작하는 코드 
      } catch (error) {
        console.error(error)
      }
    }
  
    settingLang(lang) {
      this.props.setLang(lang)
      this.toggleSelect()
    }

    toggleSelect() {
      if (this.state.lang_is_active) {
        this.setState({
          lang_is_active : false
        })
        this.langSelect.className = "btn_language"
      } else {
        this.setState({
          lang_is_active : true
        })
        this.langSelect.className = "btn_language is_active"
      }
    }

    render() {

      let LANG = "KR"
      switch(this.props.lang) {
        case 'ko': 
            LANG = "KR"
            break
        case 'en':
            LANG = "EN"
            break
        case 'cn':
            LANG = "CH"
            break
        default:
    }
      
      return (
        <div className="chat_header" onClick={() => {this.props.toggleRealtimeAnswer(true)}}>
          { this.props.fromAdvisor 
            ? <h1 className="h_tit"><span className="ico_comm ico_advisor_logo">CAU e-Advisor</span></h1>
            : <h1 className="h_tit"><span className="ico_comm ico_bot_logo"></span>{this.props.uiTexts.text_00}</h1>
          }
          { !this.props.fromAdvisor &&
            <div className="language_box">
              <button type="button" className="btn_language" onClick={()=>{this.toggleSelect()}} ref={(ref) => {this.langSelect = ref}}>{LANG} <span className="ico_comm ico_arrow">다른 언어 선택 목록 보기</span></button>
              <div className="language_inner_box">
                  <h2 className="screen_out">언어선택</h2>
                  <ul className="language_list">
                      { this.props.lang === "ko" 
                        ? <li className="language_item is_selected"><a href="./index.html?projectId=13&lang=ko" className="language_link">KR</a></li>
                        : <li className="language_item"><a href="./index.html?projectId=13&lang=ko" className="language_link">KR</a></li>
                      }
                      { this.props.lang === "en" 
                        ? <li className="language_item is_selected"><a href="./index.html?projectId=14&lang=en" className="language_link">EN</a></li>
                        : <li className="language_item"><a href="./index.html?projectId=14&lang=en" className="language_link" >EN</a></li>
                      }
                      { this.props.lang === "cn" 
                        ? <li className="language_item is_selected"><a href="./index.html?projectId=15&lang=cn" className="language_link" >CH</a></li>
                        : <li className="language_item"><a href="./index.html?projectId=15&lang=cn" className="language_link" >CH</a></li>
                      }
                  </ul>
              </div>
            </div>
          }
            <div className="btn_unit">
              <button type='button' className="menu_btn btn_edit" onClick={this.handleClickFeedback}><span className="ico_comm ico_edit">의견 작성하기</span></button>
              <button type="button" className="menu_btn btn_menu" onClick={this.handleClickSideMenu}><span className="ico_comm ico_menu">메뉴보기</span></button>
              {this.props.fromApp &&
              <button type="button" className="menu_btn btn_close" onClick={()=>{this.clickChatbotClose()}}><span className="ico_comm ico_close">챗봇닫기</span></button>
              }
            </div>
        </div>
      );
    }
};

export default ChatTop;